import { Routes } from '@angular/router';
import { HeadToHeadQueryComponent } from './head-to-head-query.component';
import { SpecifyEntriesTabComponent } from './specify-entries-step/specify-entries-tab.component';
import { LocationFilterPopupComponent } from '../shared/query/location-filter.component';
import { HEAD_TO_HEAD_QUERY_PERMISSIONS } from '../shared/auth/permissions';
import { RouteAccessService } from '../shared';
import { StudyFilterPopupComponent } from '../shared/query/study-filter.component';
import { VariableResultsTabComponent } from './display-results/variable-results-tab.component';

export const HEAD_TO_HEAD_QUERY_ROUTES: Routes = [
    {
        path: 'head-to-head-query',
        component: HeadToHeadQueryComponent,
        data: { authorities: [...HEAD_TO_HEAD_QUERY_PERMISSIONS] },
        children: [
            {
                path: 'variableId/:variableId',
                component: VariableResultsTabComponent,
                outlet: 'display-result-outlet',
                data: {
                    pageTitle: 'head-to-head-query.display.results.title'
                }
            }
        ]
    },
    {
        path: 'environments-location-filter-dialog',
        component: LocationFilterPopupComponent,
        data: { authorities: [...HEAD_TO_HEAD_QUERY_PERMISSIONS] },
        canActivate: [RouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'environments-study-filter-dialog',
        data: { authorities: [...HEAD_TO_HEAD_QUERY_PERMISSIONS] },
        canActivate: [RouteAccessService],
        component: StudyFilterPopupComponent,
        outlet: 'popup'
    }
];
